import type { Page as PageType } from 'src/types/page';
import { AdBuyingPage } from 'src/sections/services/ad-buying-page';

const Page: PageType = () => <AdBuyingPage />;

export default Page;
